export const UPDATE_CONTACTS_STATE = "UPDATE_CONTACTS_STATE"
export const CONTACT_DELETED = "CONTACT_DELETED"
export const CONTACT_CREATED = "CONTACT_CREATED"
export const CONTACTS_STATUS = "CONTACTS_STATUS"
export const CONTACTS_UPDATE = "CONTACTS_UPDATE"